import { ArchiveTitleRuleItemParamType } from './archive-title-rule-item-param-type.enum';
import {
  ArchiveTitleRuleItemDisplayType,
  ArchiveTitleRuleItemType,
} from './archive-title-rule-item-type.enum';
export class ArchiveTitleRuleItemParamInfo {
  type?: ArchiveTitleRuleItemParamType;
  example?: string;
  checked?: boolean;
  separator?: string;
  // 前端自用
  mainType?: ArchiveTitleRuleItemDisplayType;
}
